import script from "./CalendarInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./CalendarInfoDialog.vue?vue&type=style&index=0&id=e212ae74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e212ae74"]])

export default __exports__